import {useCallback, useState} from 'react';
import {captureMessage} from '@sentry/browser';
import {useProfile} from '../../Providers/ProfileProvider';
import {Profile} from '../../../generated/types';
import {SessionRetry} from './SessionRetry';

export function SessionRetryScreen() {
  const {setProfile} = useProfile();
  const [sentryEventId, setSentryEventId] = useState<string | undefined>();

  const onError = useCallback((error?: string) => {
    const msg = error ?? 'Session retry failed';
    const eventId = captureMessage(msg);
    setSentryEventId(eventId);
  }, []);

  const onSuccess = useCallback(
    (newProfile: Profile) => {
      if (newProfile.visitor.sessionType === 'anonymous') {
        onError(
          "expected authenticated profile from session retry, but didn't have one",
        );
        return;
      }

      setProfile(newProfile);
    },
    [onError, setProfile],
  );

  return (
    <SessionRetry
      onSuccess={onSuccess}
      onError={onError}
      sentryEventId={sentryEventId}
    />
  );
}
